/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const HistogramIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Histogram',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="10" rx=".5" ry=".5" width="2" x="2" y="24" />
    <rect height="18" rx=".5" ry=".5" width="2" x="6" y="16" />
    <rect height="18" rx=".5" ry=".5" width="2" x="18" y="16" />
    <rect height="14" rx=".5" ry=".5" width="2" x="26" y="20" />
    <rect height="6" rx=".5" ry=".5" width="2" x="30" y="28" />
    <rect height="28" rx=".5" ry=".5" width="2" x="10" y="6" />
    <rect height="22" rx=".5" ry=".5" width="2" x="14" y="12" />
    <rect height="24" rx=".5" ry=".5" width="2" x="22" y="10" />
  </svg>`;
};
